import React, { useEffect } from 'react';
import { Icon, Button, Form } from 'components';
import { ResetPasswordForm } from 'control-components';
import {  useSelect, useAction, useQuery } from 'hooks';
import { withForm, withFormValidation } from 'hoc';
import { Link, useHistory } from 'react-router-dom';

const initState = {
  email: '',
  password: '',
  password_confirmation: ''
}

function ResetPassword({  onChange, value, helperMessage, isPassed, onSetForm }) {
  const query = useQuery()
  const history = useHistory()
  const isLoading = useSelect('loading.isLoading', { type: 'auth.resetPassword' })
  const resetPassword = useAction('auth.resetPassword');

  useEffect(() => {
    onSetForm({
      ...value,
      email: query.get('email')
    })
  }, [])

  const handleSubmit = e => {
    e.preventDefault()
    resetPassword({
      ...value,
      token: query.get('token')
    }, () => {
      history.push('/')
    })
  }

  return (
    <>
      <div className="signup-container">
        <div className="form-container">
          <Form className="form w-full flex flex-grow" onSubmit={handleSubmit}>
            <div className="xl:!hidden lg:!hidden flex flex-col items-center justify-center flex-grow">
              <Icon.Logo className="lw-36 h-36"/>
              <span className="text-xs text-center">Land Transportation Franchising & Regulatory Board</span>
              <span className="text-sm font-bold text-center">Online Application and Issuance of Certificate of Public Convenience</span>
            </div>
            <div className="hidden xl:flex lg:flex flex-grow justify-center">
              <Icon.Logo className="lw-36 h-36"/>
            </div>
            <div className="flex xl:!pb-10 pb-3">
              <Link to="/reset-password" className="w-full h-16 flex text-black items-center justify-start"><span className="xl:!text-2xl lg:text-xl text-sm font-bold">Reset Password</span></Link>
            </div>
            <ResetPasswordForm value={value} onChange={onChange} helperMessage={helperMessage}/>
            <Button
              isLoading={isLoading}
              disabled={!isPassed}
              className="!bg-warning !text-black h-12 xl:!mt-10 mt-3"
            >
              <span>Submit</span>
            </Button>
            <Link to="/" className="forgot-password-link">Sign In?</Link>
          </Form>
        </div>
        <div className="brand xl:!flex lg:!flex !hidden">
          <div className="content">
            <span className="title">Land Transportation Franchising & Regulatory Board</span>
            <span className="sub-title">Online Application and Issuance of Certificate of Public Convenience</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default withForm(withFormValidation(ResetPassword,
  {
    email: 'required|email',
    password: 'required|password',
    password_confirmation: 'required|min_eight|same:password'
  },
), initState);
